import { useEffect, useState } from "react";
import { HttpMainApi } from "../../../interface/main-api";
import type { WeatherQueryResult, WeeklyWeatherInfo } from "../weatherTypes";

const WEATHER_COORDS = { lat: 37.76, lon: 126.78 };
const mainApi = new HttpMainApi();

export const useWeeklyWeatherInfo = (): WeatherQueryResult<WeeklyWeatherInfo> => {
  const [data, setData] = useState<WeeklyWeatherInfo>();
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    let mounted = true;

    const loadWeeklyWeatherInfo = async () => {
      setIsSuccess(false);
      const response = await mainApi.get_weekly_weather_info({ params: WEATHER_COORDS });
      if (!mounted) return;

      const responseBody = response?.response ?? response;
      setData({
        weeklyWeatherInfo: responseBody?.weeklyWeatherInfo ?? [],
        region: responseBody?.region ?? "",
      });
      setIsSuccess(true);
    };

    loadWeeklyWeatherInfo();

    return () => {
      mounted = false;
    };
  }, []);

  return { data, isSuccess };
};
